import React,{useState} from "react";

import Alphabet from "../../alphabet/Alphabet.container";
import {styleAlphabet} from "../../../assets/alphabet/alphabet";

const EnglishLetterHidden = () =>{
    const [gameAlphabet,setGameAlphabet] = useState(styleAlphabet || []);
    return <div className="englishLetter">
        <Alphabet
            hideLogo={true}
            isGame = {true}
            gameAlphabet = {gameAlphabet}
            // withWinsIcons={true}
            // randomLetter={randomLetter}
            callback = {(letter)=>{
            const filteredAlphabet  =    gameAlphabet.map(obj=>{
                if(obj.letter === letter) {
                    obj.hidden = true;
                }
                return obj;
                })
                setGameAlphabet(filteredAlphabet);
                // if(randomLetter === letter) {
                //     setTimeout(()=>{startGameLetterVoice(alphabets)},1000)
                // }
            }
        }
        />
    </div>
}

export default EnglishLetterHidden;